// extracted by mini-css-extract-plugin
module.exports = {"dim":"CloseLayer_dim__uSrjN"};